import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FamilyRegistrationService } from '../family-registration.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { LinkAlreadySentComponent } from '../link-already-sent/link-already-sent.component';
import { LoginExistsComponent } from '../login-exists/login-exists.component';
import { DuplicateEmailAddressComponent } from '../duplicate-email-address/duplicate-email-address.component';
import { EmailSentComponent } from '../email-sent/email-sent.component';
import { LoginService } from '../../../shared-modules/login/login.service';
import { EmailNotSentComponent } from '../email-not-sent/email-not-sent.component';
import {System} from '../../../shared-components/System';

@Component({
  selector: 'app-register-new-family',
  templateUrl: './register-new-family.component.html',
  styleUrls: [
      './register-new-family.component.css',
      '../familiy-registration-shared-style.css'
    ]
})
export class RegisterNewFamilyComponent implements OnInit {
  @ViewChild('email', { static: true }) inputEmail: ElementRef;
  registerNewFamily: any;
  public errorList: ErrorList[] = [];
  linkAlreadySentDialogRef: MatDialogRef<LinkAlreadySentComponent>;
  loginExistsDialogRef: MatDialogRef<LoginExistsComponent>;
  duplicateEmailDialogRef: MatDialogRef<DuplicateEmailAddressComponent>;
  emailSentDialogRef: MatDialogRef<EmailSentComponent>;
  emailNotSentDialogRef: MatDialogRef<EmailNotSentComponent>;
  dialogWidth: number;
  @ViewChild('dialogWindow', { read: ElementRef }) dialogWindow: ElementRef;
  V10: boolean;


  constructor(
    private familyRegistrationService: FamilyRegistrationService,
    private dialogRef: MatDialogRef<RegisterNewFamilyComponent>,
    private loginService: LoginService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.registerNewFamily = this.familyRegistrationService.registerNewFamily;
    this.V10 = this.loginService.LoginSettings.V10;
  }

  modalInstancePreviousClick() {
    this.registerNewFamily.emailAddress = '';
    this.dialogRef.close('Register New Family Message');
    this.dialogWidth = this.dialogWindow.nativeElement.width;
  }

  modalInstanceNextClick() {
    if (this.validate()) {
      this.dialogRef.close('Next was clicked.');

      this.loginService.getClientInformation().subscribe(
        (clientInfo) => {
          if (clientInfo) {
          	const baseURL = window.location.href.slice(0, window.location.href.includes('?') ? window.location.href.indexOf('?') : window.location.href.length);
            this.familyRegistrationService.registerParent(this.registerNewFamily.emailAddress, this.registerNewFamily.languageId, baseURL, clientInfo[0], clientInfo[1], clientInfo[2]).subscribe(
              (results) => {
                if (results == 'Link Already Sent') {
                  this.linkAlreadySentDialogRef = this.dialog.open(LinkAlreadySentComponent, {
                    panelClass: 'tyl-mat-dialog',
                  });
                }
                else if (results == 'Login Exists') {
                  this.loginExistsDialogRef = this.dialog.open(LoginExistsComponent, {
                    panelClass: 'tyl-mat-dialog',
                  });
                }
                else if (results == 'Duplicate Email Address') {
                  this.duplicateEmailDialogRef = this.dialog.open(DuplicateEmailAddressComponent, {
                    panelClass: 'tyl-mat-dialog',
                  });
                }
                else if (results == 'Message not sent') {
                  this.emailNotSentDialogRef = this.dialog.open(EmailNotSentComponent, {
                    panelClass: 'tyl-mat-dialog',
                  });
                }
                else {
                  this.emailSentDialogRef = this.dialog.open(EmailSentComponent, {
                    panelClass: 'tyl-mat-dialog',
                    data: {
                        registerNewFamily: this.registerNewFamily
                    }
                  });
                }
              },
            () => {
              this.emailNotSentDialogRef = this.dialog.open(EmailNotSentComponent, {
                panelClass: 'tyl-mat-dialog',
              });
            });
          }
        });
    }
  }

  validate(): boolean {
    const mailformat = System.mailRegexp;
    this.errorList = [];
    if (this.registerNewFamily.emailAddress == null || this.registerNewFamily.emailAddress == '') {
      this.errorList.push({
        fieldName: 'Email',
        fieldRef: this.inputEmail,
        errorMsg: 'Field is required'
      });
      return false;
    }
    else if (this.registerNewFamily.emailAddress.match(mailformat) == null) {
      this.errorList.push({
        fieldName: 'Email',
        fieldRef: this.inputEmail,
        errorMsg: 'Invalid Email Address'
      });
      return false;
    }
    else {
      return true;
    }
  }

  modalInstanceCancelClick() {
    this.registerNewFamily.emailAddress = '';
    this.dialogRef.close('Cancel was clicked.');
  }

}
